/*
* 系统常量数据：新手引导动画、登录token、系统常量
* 新手指引动画 https://kamranahmed.info/driver.js/#
* const driver = new Driver({
* className: 'scoped-class', // className来包装driver.js弹出框
* animate: true,  // 更改突出显示的元素时进行动画处理
* opacity: 0.75,  // 背景不透明度（0表示仅弹出窗口，没有覆盖）
* padding: 10,    // 元素到边缘的距离
* allowClose: true, // 单击覆盖是否应该关闭
* overlayClickNext: false, // 是否应移至覆盖图的下一步，请点击
* doneBtnText: 'Done', // 最终按钮上的文字
* closeBtnText: 'Close', // 此步骤关闭按钮上的文字
* nextBtnText: 'Next', // 此步骤的下一步按钮文字
* prevBtnText: 'Previous', // 此步骤的上一个按钮文字
* showButtons: false, // 不要在页脚中显示控制按钮
* keyboardControl: true, //允许通过键盘进行控制（退出键可关闭，箭头键可移动）
* scrollIntoViewOptions: {}, // 我们在可能的情况下使用`scrollIntoView（）`，如果您需要的话，在此处传递选项
* onHighlightStarted: (Element) {}, // 在元素将要突出显示时调用
* onHighlighted: (Element) {}, //当元素完全突出显示时调用
* onDeselected: (Element) {}, // 取消选择元素时调用
* onReset: (Element) {},        // 在即将清除叠加层时调用
* onNext: (Element) => {},      // 在任何步骤上移至下一步时调用
* onPrevious: (Element) => {},  // 在任何步骤上移至下一步时调用
* });
*
* const stepDefinition = {
* element: '#some-item',        // Query selector string or Node to be highlighted
* popover: {                    // There will be no popover if empty or not given
*   className: 'popover-class', // className to wrap this specific step popover in addition to the general className in Driver options
*   title: 'Title',             // Title on the popover
*   description: 'Description', // Body of the popover
*   showButtons: false,         // Do not show control buttons in footer
*   closeBtnText: 'Close',      // Text on the close button for this step
*   nextBtnText: 'Next',        // Next button text for this step
*   prevBtnText: 'Previous',    // Previous button text for this step
* }
* };
* const driver = new Driver(driverOptions);
* const isActivated = driver.isActivated; // Checks if the driver is active or not
* driver.moveNext();     // Moves to next step in the steps list
* driver.movePrevious(); // Moves to previous step in the steps list
* driver.start(stepNumber = 0);  // Starts driving through the defined steps
* driver.highlight(string|stepDefinition); // highlights the element using query selector or the step definition
* driver.reset(); // Resets the overlay and clears the screen
* driver.hasHighlightedElement(); // Checks if there is any highlighted element
* driver.hasNextStep(); // Checks if there is next step to move to
* driver.hasPreviousStep(); // Checks if there is previous step to move to
*
* // Prevents the current move. Useful in `onNext` or `onPrevious` if you want to
* // perform some asynchronous task and manually move to next step
* driver.preventMove();
*
* // Gets the currently highlighted element on screen
* const activeElement = driver.getHighlightedElement();
* const lastActiveElement = driver.getLastHighlightedElement();
* activeElement.getCalculatedPosition(); // Gets screen co-ordinates of the active element
* activeElement.hidePopover();  // Hide the popover
* activeElement.showPopover();  // Show the popover
*
* activeElement.getNode();  // Gets the DOM Element behind this element
*
* */
//引入路由对象，创建全局统一路由跳转的控制方法
import router from './../../router';
import {convertBase64UrlToFile} from './../../util'

const state = {
  //系统常量
  constant: {
    onlineService: 'http://www.banniu.im/playBN', //在线客服
    microBlog: 'https://weibo.com/5705151777/profile?topnav=1&wvr=6', //微博
    errImage: 'https://workfile2.banniuyun.com/125_10030158_1576824649029.jpg',//系统图片加载失败后暂时的默认图片
  },
  //上传文件的地址路径
  // uploaderPath:window.location.host.includes('8088')?'http://39.98.141.22:30000/v2/attachment/upload/task':'/v2/attachment/upload/task',
  uploaderPath: window.location.host.includes('8089') ? 'https://test2.banniu.im/v2/attachment/upload/task' : '/v2/attachment/upload/task',
  // uploaderPath:window.location.host.includes('8088')?'https://test.banniu.im/v2/attachment/upload/task':'/v2/attachment/upload/task',
  //localPath，拼接用的请求接口地址
  // localPath:window.location.host.includes('8088')?'http://39.98.141.22:30000':'https://'+window.location.host,
  localPath: window.location.host.includes('8089') ? 'https://test2.banniu.im' : 'https://' + window.location.host,
  //需要跳转到班牛的path地址
  bnLocal: window.location.host.includes('8089') ? 'http://localhost:9000/src' : (window.location.host.includes('30005') ? 'http://' + window.location.host : 'https://' + window.location.host),
  //设备信息
  information: '',
  //滚动条配置 详情：https://vuescrolljs.yvescoding.org/zh/guide/api.html#scrollintoview-selector-speed
  scrollConfigs: {
    //默认配置
    defaultConfig: {
      vuescroll: {
        sizeStrategy: 'percent',
        detectResize: true
      },
      rail: {
        opacity: 0,
        size: '8px',
        specifyBorderRadius: false,
        gutterOfEnds: null,
        gutterOfSide: '2px',
        keepShow: false
      },
      scrollPanel: {
        scrollingX: false,
      },
      bar: {
        showDelay: 500,
        onlyShowBarOnScroll: false,
        keepShow: false,
        background: 'rgba(144,147,153,.3)',
        opacity: 1,
        hoverStyle: true,
        specifyBorderRadius: false,
        minSize: 0.2,
        size: '8px',
        disable: false,
      },
      scrollButton: {
        enable: false,
        background: 'rgb(3, 185, 118)',
        opacity: 1,
        step: 180,
        mousedownStep: 30
      }
    },
    //单独位置的配置，尽量和路由的name相匹配
    walkPoint: {
      vuescroll: {
        sizeStrategy: 'percent',
        detectResize: true
      },
      rail: {
        opacity: 0,
      },
      bar: {
        opacity: 0,
      },
    },
  },   
  //默认破碎图片
  // brokenPicture: 'https://workfile2.wangjubao.com/125_7_1578990974871.png',
  brokenPicture: 'https://workfile2.banniuyun.com/125_7_1578990974871.png',
  //用户默认头像
  defaultUserImg: 'https://workfile2.banniuyun.com/125_7_1578992324283.png',
};
const mutations = {
  SET_UPLOADER_PATH(state, url) {
    state.uploaderPath = url
  },
};
const actions = {
  //路由跳转，统一使用该方法
  routerJump({commit}, data) {
    router.push(data).catch(err => {
    })
  },
//通过复制粘贴上传一张图片
  pasteImg({commit, state}, evt) {
    return new Promise((resolve, reject) => {
      if (evt.clipboardData && evt.clipboardData.items) {
        let items = Array.prototype.filter.call(evt.clipboardData.items, element => {
          return element.type.indexOf("image") >= 0;
        });
        Array.prototype.forEach.call(items, item => {
          let blob = item.getAsFile();
          let reader = new FileReader();
          reader.onloadend = event => {
            let imgBase64 = event.target.result;
            let file = convertBase64UrlToFile(imgBase64)
            let formData = new FormData();
            formData.append('file', file);
            let xhr = new XMLHttpRequest();
            xhr.open('POST', state.uploaderPath);
            xhr.onload = () => {
              if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                  let res = JSON.parse(xhr.responseText);
                  resolve(res)
                } else {
                  resolve({code: 8080, msg: '你的浏览器不支持复制上传图片'})
                }
              }
            };
            xhr.onerror = function (e) {
              resolve({code: 8080, msg: '你的浏览器不支持复制上传图片'})
            };
            xhr.send(formData);
          };
          reader.readAsDataURL(blob);
        });
      } else {
        resolve({code: 8080, msg: '你的浏览器不支持复制上传图片'})
      }
    })
  },
//像文本框光标所在位置插入字符。传入DOM对象和字符。返回一个拼装完整的字符串
  insertText({commit, state}, {dom, value}) {
    return new Promise((resolve, reject) => {
      let selectRange;
      if (document.selection) {
        // IE Support
        dom.focus();
        selectRange = document.selection.createRange();
        selectRange.text = value;
        dom.focus();
      } else if (dom.selectionStart || dom.selectionStart == '0') {
        // Firefox support
        let startPos = dom.selectionStart;
        let endPos = dom.selectionEnd;
        let scrollTop = dom.scrollTop;
        dom.value = dom.value.substring(0, startPos) + value + dom.value.substring(endPos, dom.value.length);
        dom.focus();
        dom.selectionStart = startPos + value.length;
        dom.selectionEnd = startPos + value.length;
        dom.scrollTop = scrollTop;
      } else {
        dom.value += value;
        dom.focus();
      }
      resolve(dom.value);
    })
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/system.js